import type { AppConfig } from '@plato/app-meta/app-config-type';
import { useContext } from 'react';
import { AppConfigContext } from '../context/app-config.ts';

export function useAppConfig(): AppConfig {
    const appConfig = useContext(AppConfigContext);

    if (!appConfig) {
        throw new Error('useAppConfig must be used within an AppConfigContext provider');
    }

    return appConfig;
}
